export const MAIL_SEND_REQUEST = 'MAIL_SEND_REQUEST';
export const MAIL_SEND_SUCCESS = 'MAIL_SEND_SUCCESS';
export const MAIL_SEND_FAIL = 'MAIL_SEND_FAIL';
export const MAIL_SEND_RESET = 'MAIL_SEND_RESET';
